import '../../assets/index27.css';var $ = Object.defineProperty, q = Object.defineProperties;
var G = Object.getOwnPropertyDescriptors;
var b = Object.getOwnPropertySymbols;
var x = Object.prototype.hasOwnProperty, D = Object.prototype.propertyIsEnumerable;
var I = (n, r, s) => r in n ? $(n, r, { enumerable: !0, configurable: !0, writable: !0, value: s }) : n[r] = s, N = (n, r) => {
  for (var s in r || (r = {}))
    x.call(r, s) && I(n, s, r[s]);
  if (b)
    for (var s of b(r))
      D.call(r, s) && I(n, s, r[s]);
  return n;
}, A = (n, r) => q(n, G(r));
var F = (n, r) => {
  var s = {};
  for (var l in n)
    x.call(n, l) && r.indexOf(l) < 0 && (s[l] = n[l]);
  if (n != null && b)
    for (var l of b(n))
      r.indexOf(l) < 0 && D.call(n, l) && (s[l] = n[l]);
  return s;
};
import { jsx as i, jsxs as _ } from "react/jsx-runtime";
import { forwardRef as H, useState as K, useMemo as g } from "react";
import { SearchBar as W } from "../SearchBar/index.js";
import { Stack as J } from "../Stack/index.js";
import { Text as Q } from "../Text/index.js";
import { AngleDownFarFAIcon as X, CircleExclamationFarFAIcon as Y } from "../Icons/index.js";
import { g as Z, a as ee, u as oe, C as u } from "../../Combobox-5HUj9q7L.js";
import { u as ne } from "../../use-uncontrolled-BT_j5D2R.js";
import { I as te } from "../../InputBase-Cabx1d9o.js";
const le = "InlineSelect-module__inlineSelectRoot___68jD5", re = "InlineSelect-module__searchContainer___IRF7H", se = "InlineSelect-module__inlineSelect___NwoUe", ie = "InlineSelect-module__options___5USp9", ae = "InlineSelect-module__option___KyvwU", ce = "InlineSelect-module__emptyState___eOvWq", d = {
  inlineSelectRoot: le,
  searchContainer: re,
  inlineSelect: se,
  options: ie,
  option: ae,
  emptyState: ce
}, pe = H(
  (de, P) => {
    var v = de, {
      allowDeselect: n = !1,
      defaultValue: r,
      disabled: s,
      data: l,
      placeholder: L,
      onChange: R,
      value: k,
      className: j,
      width: M,
      variant: f = "default",
      searchPlaceholder: U = "Search...",
      children: z
    } = v, B = F(v, [
      "allowDeselect",
      "defaultValue",
      "disabled",
      "data",
      "placeholder",
      "onChange",
      "value",
      "className",
      "width",
      "variant",
      "searchPlaceholder",
      "children"
    ]);
    const [c, y] = K(""), p = g(() => Z(l), [l]), V = g(() => f !== "searchable" || !c ? p : p.filter(
      (t) => {
        var e;
        return (e = t == null ? void 0 : t.label) == null ? void 0 : e.toLowerCase().includes(c.toLowerCase());
      }
    ), [p, c, f]), O = g(() => ee(p), [p]), a = oe({
      onDropdownClose: () => {
        a.resetSelectedOption(), f === "searchable" && y("");
      },
      onDropdownOpen: (t) => {
        t === "keyboard" ? a.selectActiveOption() : a.updateSelectedOptionIndex("active");
      }
    }), E = () => {
      if (!l || l.length === 0) return "";
      if (!Array.isArray(l))
        return p.length > 0 ? p[0].value : "";
      for (const t of l) {
        if (typeof t == "string")
          return t;
        if ("group" in t) {
          if (t.items.length > 0) {
            const e = t.items[0];
            return typeof e == "string" ? e : e.value;
          }
        } else
          return t.value;
      }
      return "";
    }, [h, C] = ne({
      value: k,
      defaultValue: r || E(),
      onChange: R
    }), m = typeof h == "string" ? O[h] : void 0, T = (t) => {
      const e = O[t];
      if (n && t === h) {
        C("", e), a.updateSelectedOptionIndex("active"), a.closeDropdown();
        return;
      }
      C(t, e), a.updateSelectedOptionIndex("active"), a.closeDropdown();
    }, w = (() => {
      if (!Array.isArray(l))
        return V.map((e, S) => /* @__PURE__ */ i(
          u.Option,
          {
            active: e.value === h,
            value: e.value,
            onMouseOver: () => a.selectOption(S),
            className: d.option,
            disabled: e.disabled,
            children: e.label
          },
          e.value
        ));
      let t = 0;
      return l.map((e) => {
        if (typeof e == "string" || !("group" in e)) {
          const o = typeof e == "string" ? { label: e, value: e } : e;
          return f !== "searchable" || !c || o.label.toLowerCase().includes(c.toLowerCase()) ? /* @__PURE__ */ i(
            u.Option,
            {
              active: o.value === h,
              value: o.value,
              onMouseOver: () => a.selectOption(t++),
              className: d.option,
              disabled: o.disabled,
              children: o.label
            },
            o.value
          ) : null;
        }
        const S = e.items.filter(
          (o) => f !== "searchable" || !c || (typeof o == "string" ? o : o.label).toLowerCase().includes(c.toLowerCase())
        );
        return S.length === 0 ? null : /* @__PURE__ */ i(u.Group, { label: e.group, children: S.map((o) => /* @__PURE__ */ i(
          u.Option,
          {
            active: (typeof o == "string" ? o : o.value) === h,
            value: typeof o == "string" ? o : o.value,
            onMouseOver: () => a.selectOption(t++),
            className: d.option,
            disabled: typeof o == "string" ? !1 : o.disabled,
            children: typeof o == "string" ? o : o.label
          },
          typeof o == "string" ? o : o.value
        )) }, e.group);
      }).filter(Boolean);
    })();
    return /* @__PURE__ */ i("div", { className: d.inlineSelectRoot, children: /* @__PURE__ */ _(
      u,
      {
        store: a,
        onOptionSubmit: T,
        withinPortal: !1,
        disabled: s,
        position: "bottom-start",
        offset: 0,
        children: [
          /* @__PURE__ */ i(u.Target, { children: /* @__PURE__ */ i(
            te,
            A(N({
              disabled: s,
              component: "button",
              type: "button",
              onClick: () => a.toggleDropdown(),
              pointer: !0,
              rightSection: /* @__PURE__ */ i(X, { size: 12, color: "var(--plum-gray-8)" }),
              rightSectionPointerEvents: "none",
              classNames: {
                input: `${d.inlineSelect} ${j || ""}`
              },
              style: { width: M },
              ref: P
            }, B), {
              children: (m == null ? void 0 : m.label) || (p.length > 0 ? p[0].label : L)
            })
          ) }),
          /* @__PURE__ */ _(u.Dropdown, { children: [
            f === "searchable" && /* @__PURE__ */ i("div", { className: d.searchContainer, children: /* @__PURE__ */ i(
              W,
              {
                "data-plum-id": "inline-select-search",
                placeholder: U,
                value: c,
                onChange: y
              }
            ) }),
            /* @__PURE__ */ i(u.Options, { className: d.options, children: w.length > 0 ? w : f === "searchable" && c ? /* @__PURE__ */ _(J, { className: d.emptyState, children: [
              /* @__PURE__ */ i(Y, { size: 24 }),
              /* @__PURE__ */ i(Q, { size: "md", prominent: !0, c: "gray.7", children: "No results found" })
            ] }) : null }),
            z
          ] })
        ]
      }
    ) });
  }
), ue = Object.assign(pe, {
  Footer: u.Footer
});
ue.displayName = "InlineSelect";
export {
  ue as InlineSelect
};
